import React from 'react';
import '../App.css';

class Modal extends React.Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }

  render() {
    return (
      <div className="modal-overlay">
        <div className="modal-wrapper">
          <div className="modal-header">
            <button className="close-button" onClick={this.props.onClose}>&times;</button>
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Modal;
